import {
  makeStyles,
  Theme,
  createStyles,
  Typography,
  Grid,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core'
import React, { useState } from 'react'
import TextField from '../TextField/TextField'
import clsx from 'clsx'
import Button from '../Button/Button'
import CMSText from '../Global/CMSText'
import { useTranslation } from 'react-i18next'
import router from 'next/router'
import { numberToPrice } from '../../utils/utils'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { useCart } from '../../hooks/useCart'

type Tprops = {
  skiText: any
  product: any
  variantCode: any
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    selectLabel: {
      display: 'block',
      cursor: 'pointer',
      textAlign: 'inherit',
      fontSize: 11,
      paddingLeft: theme.spacing(1.25),
      marginBottom: theme.spacing(0.5),
    },
    select: {
      display: 'block',
      padding: theme.spacing(1, 0.5),
      fontFamily: theme.typography.fontFamily,
      width: '100%',
      fontSize: 14,
      borderRadius: theme.shape.borderRadius,
      border: `1px solid ${theme.extraColors.greyLight}`,
      color: theme.typography.body1.color,
      backgroundColor: theme.extraColors.greyLight,
    },
    checkboxText: {
      fontStyle: 'italic',
    },
    buttonSki: {
      float: 'right',
    },
    skiForm: {
      '& label': {
        paddingLeft: '5px',
      },
    },
  })
)

const ProductSkiForm = ({ skiText, product, variantCode }: Tprops) => {
  const classes = useStyles()
  const { addProductToCart } = useCart()
  const [weight, setWeight] = useState('')
  const [size, setSize] = useState('')
  const [age, setAge] = useState('inférieur à 10 ans')
  const array = []
  skiText?.data?.levels?.map((level) => {
    array.push({ level: level?.level[0]?.text, label: level?.level[0]?.text })
  })
  const options =
    typeof skiText?.data?.levels === 'undefined'
      ? [
          { level: 'Débutant', label: 'Débutant' },
          { level: 'Intermédiaire', label: 'Intermédiaire' },
          { level: 'Confirmé', label: 'Confirmé' },
        ]
      : array
  const ageOptions = [
    { age: 'inférieur à 10 ans', label: 'inférieur à 10 ans' },
    { age: '11 ans à 49 ans', label: '11 ans à 49 ans' },
    { age: 'supérieur à 50 ans', label: 'supérieur à 50 ans' },
  ]
  const [level, setLevel] = useState(options[0]?.level)
  const [firstname, setFirstname] = useState('')
  const [sizeCheckbox, setSizeCheckbox] = useState(false)
  const [skiArray, setSkiArray] = useState([])
  const { t } = useTranslation()
  const { trackEvent } = useMatomo()

  const handleSizeBox = () => {
    setSizeCheckbox(!sizeCheckbox)
  }

  const handleLevel = (event) => {
    setLevel(event.target.value)
  }
  const handleAge = (event) => {
    setAge(event.target.value)
  }

  const handleAddProduct = () => {
    const currentArray = [...skiArray]

    currentArray.push({
      size: parseInt(size),
      weight: parseInt(weight),
      level: level,
      firstname: firstname,
      age: age,
    })

    const price = numberToPrice(
      product.item?.variants[variantCode]?.price?.current
    )

    addProductToCart({
      productCode: product.code,
      quantity: 1,
      variantCode,
      skis: currentArray,
    })

    trackEvent({
      category: 'Add to Cart for tryout',
      action: `${product?.item?.name}`,
      name: `${router.pathname}`,
      value: price,
    })

    setSkiArray([])
  }

  return (
    <Grid container spacing={1} className={classes.skiForm}>
      <Grid item xs={12}>
        <Typography>
          <CMSText
            asText
            data={skiText?.data?.try_out}
            defaultText={t('texts:skiText:title')}
          />
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <TextField
          label={
            <CMSText
              asText
              data={skiText?.data?.weight_label}
              defaultText={t('texts:skiText:weight_label')}
            />
          }
          type="number"
          name="weight"
          min={0}
          placeholder={'70'}
          value={weight}
          required={true}
          onChange={setWeight}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label={
            <CMSText
              asText
              data={skiText?.data?.size_label}
              defaultText={t('texts:skiText:size_label')}
            />
          }
          type="number"
          name="weight"
          placeholder={'172'}
          min={0}
          value={size}
          required={true}
          onChange={setSize}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label={
            <CMSText
              asText
              data={skiText?.data?.firstname}
              defaultText={t('texts:skiText:firstname')}
            />
          }
          type="text"
          name="fistname"
          placeholder={'John'}
          value={firstname}
          required={true}
          onChange={setFirstname}
        />
      </Grid>
      <Grid item xs={6}>
        <label className={clsx(classes.selectLabel, 'label')}>
          <CMSText
            asText
            data={skiText?.data?.level_label}
            defaultText={t('texts:skiText:level_label')}
          />
        </label>
        <select
          value={level}
          onChange={handleLevel}
          required={true}
          defaultValue={options[0]?.value}
          name="select"
          className={clsx(classes.select, 'select')}
        >
          {options?.map((option, index) => {
            return (
              <option value={option?.level} key={index}>
                {option?.label}
              </option>
            )
          })}
        </select>
      </Grid>
      <Grid item xs={6}>
        <label className={clsx(classes.selectLabel, 'label')}>
          <CMSText
            asText
            data={skiText?.data?.age_label}
            defaultText={t('texts:skiText:age_label')}
          />
        </label>
        <select
          value={age}
          onChange={handleAge}
          required={true}
          defaultValue={ageOptions[0]?.age}
          name="select"
          className={clsx(classes.select, 'select')}
        >
          {ageOptions?.map((option, index) => {
            return (
              <option value={option?.age} key={index}>
                {option?.label}
              </option>
            )
          })}
        </select>
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={sizeCheckbox}
              onChange={handleSizeBox}
              name="checkedA"
            />
          }
          label={
            <Typography
              variant={'body2'}
              component={'div'}
              className={classes.checkboxText}
            >
              <CMSText
                asText
                data={skiText?.data?.shoes_size_commitment}
                defaultText={t('texts:skiText:shoes_size_commitment')}
              />
            </Typography>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <Button
          className={clsx(classes.buttonSki, 'product__btn-addtocart')}
          variant="contained"
          color="primary"
          disabled={
            firstname === '' ||
            sizeCheckbox === false ||
            weight === '' ||
            level === '' ||
            age === '' ||
            size === ''
          }
          onClick={() => handleAddProduct()}
        >
          <CMSText
            asText
            data={skiText?.data?.button_text}
            defaultText={t('texts:skiText:button_text')}
          />
        </Button>
      </Grid>
    </Grid>
  )
}

export default ProductSkiForm
